
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/[[...slug]]",
      function () {
        return require("private-next-pages/catalog/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/[[...slug]]"])
      });
    }
  